import { Injectable, signal } from '@angular/core';
import { Project } from '../models';

/**
 * Shared state service for cross-component navigation.
 * PortfolioComponent writes → AppComponent reads.
 */
@Injectable({ providedIn: 'root' })
export class NavigationService {
  /** Currently selected project to display in detail view. Null = show router outlet. */
  readonly selectedProject = signal<Project | null>(null);

  open(project: Project): void {
    this.selectedProject.set(project);
    window.scrollTo(0, 0);
  }

  close(): void {
    this.selectedProject.set(null);
    window.scrollTo(0, 0);
  }

  update(project: Project): void {
    this.selectedProject.set(project);
  }
}
